import ApplicationAdapter from './application';

export default class BroadcastTriggerAdapter extends ApplicationAdapter {
  buildURL(modelName, id, snapshot, requestType, query) {
    let url = super.buildURL(...arguments);
    let campaignId;
    if (id?.includes('-')) {
      // trigger IDs are strings of the format campaignID-triggerId (e.g. 4-1),
      // so we can easily pull the campaign's ID out of that string
      [campaignId] = id.split('-');
    } else if (query?.campaign_id) {
      campaignId = query.campaign_id;
    } else if (snapshot?.belongsTo('campaign')) {
      campaignId = snapshot.belongsTo('campaign').id;
    }

    if (!campaignId) {
      return url;
    }

    let urlArray = url.split('/');
    let triggersIndex = urlArray.indexOf('triggers');
    urlArray.splice(triggersIndex, 0, 'campaigns', campaignId);
    return urlArray.join('/');
  }

  pathForType() {
    return super.pathForType('trigger');
  }
}
